import React, { useEffect, useState } from "react";
import "./moreImage.css";
import Resizer from "react-image-file-resizer";
import { CircularProgress } from "@material-ui/core";

const MoreImage = (props) => {
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState(null);
  const { name } = props;
  const { disable } = props;
  const { placeholder } = props;

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  const resizeFile = (file) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1000,
        1000,
        "JPEG",
        90,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
      );
    });
  };

  const upload = async (e) => {
    const files = e.target.files;
    for (let i = 0; i < files?.length; i++) {
      try {
        const file = files[i];
        const image = await resizeFile(file);
        setSrc(image);
        props.onChange(image);
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <div className={`uploader ${disable && "disable"}`}>
      <input
        multiple={true}
        name={name}
        id={name}
        type={"file"}
        onChange={(e) => upload(e)}
      />
      <label htmlFor={name}>
        <div className={"uploader_icon"}>
          {loading ? (
            <CircularProgress
              size={100}
              sx={{
                color: "red",
                position: "absolute",
                top: -6,
                left: -6,
                zIndex: 1,
              }}
            />
          ) : (
            <>
              بارگزاری تصاویر
              {placeholder}
            </>
          )}
        </div>
      </label>
    </div>
  );
};

export default MoreImage;
